<template>
<w-setting-sliding-popup ref="slidingPopup" :title="titleName" @close="closePopup">
  <el-form slot="content" :model="scriptInfo" :rules="rules" label-position="top" ref="scriptInfoForm">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="스크립트명" prop="templateName">
          <el-input v-model="scriptInfo.templateName" placeholder="입력해 주세요."></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="스크립트 종류" :rules="{ required: true, trigger: 'blur', message: '값을 입력해주세요' }">
          <el-select v-model="scriptTypeId" placeholder="입력해 주세요." @change="changeSelectNode">
            <el-option v-for="item in templateTypeList" :key="item.templateTypeId" :label="item.templateTypeName" :value="item.templateTypeId"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="스크립트 설명" prop="templateDescr">
          <el-input v-model="scriptInfo.templateDescr" placeholder="입력해 주세요."></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="스크립트" prop="script">
          <span slot="label">
            <span class="mr-r4">스크립트</span>
            <w-script-keyword-legend/>
          </span>
          <el-input type="textarea" v-model="scriptInfo.script" :rows="20" placeholder="입력해 주세요."></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" class="mr-r4" type="solid" @click="saveScriptData">저장</el-button>
    <el-button size="large" @click="cancelScriptData">취소</el-button>
  </el-row>
</w-setting-sliding-popup>
</template>

<script>
import { isNil, isUndefined, clone } from 'lodash';
import msgUtil from '@/utils/message';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import WScriptKeywordLegend from '@/components/button/ScriptKeywordLegend';

export default {
  name: 'WScriptSettingPopup',
  components: {
    WScriptKeywordLegend,
  },
  props: {
    editRow: Object,
    popupType: String,
    templateTypeList: {
      type: Array,
      default: () => [],
    },
    activeCompanyId: Number,
  },
  data() {
    return {
      formName: 'scriptInfoForm',
      titleName: '',
      scriptInfo: {
        templateId: null,
        templateTypeName: null,
        templateName: null,
        templateTypeId: null,
        templateDescr: null,
        script: null,
      },
      scriptTypeId: null,
      rules: {
        templateName: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
            message: '필수 정보입니다.',
          },
        ],
      },
    };
  },
  watch: {
    editRow: {
      handler(row) {
        this.scriptInfo = clone(row);
        if (this.popupType === 'ADD') {
          this.titleName = '스크립트 추가';
          this.scriptTypeId = this.templateTypeList[0].templateTypeId;
        } else {
          this.titleName = `[${row.templateName}] 정보 수정`;
          this.scriptTypeId = row.templateTypeId;
        }
        // if (this.templateTypeList.length > 0) {
        //   if (this.popupType === 'ADD') {
        //     this.scriptTypeId = this.templateTypeList[0].templateTypeId;
        //   }
        // }
      },
      immediate: true,
    },
  },
  methods: {
    closePopup() {
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    saveScriptData() {
      const me = this;
      const saveParams = me.scriptInfo;
      me.$refs[me.formName].validate((valid) => {
        if (valid) {
          if (me.popupType === 'ADD') {
            saveParams.objCompanyId = me.activeCompanyId;
            saveParams.templateTypeId = me.scriptTypeId;
            NetdeviceSettingAPI.insertNcmTemplate(saveParams).then((response) => {
              if (response.data.success) {
                me.closePopup();
                me.$emit('reload-data');
              }
              this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '스크립트', response.data.success));
            });
          } else if (me.popupType === 'EDIT') {
            saveParams.templateTypeId = me.scriptTypeId;
            NetdeviceSettingAPI.updateNcmTemplate(saveParams).then((response) => {
              if (response.data.success) {
                me.closePopup();
                me.$emit('reload-data');
              }
              this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '스크립트', response.data.success));
            });
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('필수사항을 입력해주세요.'));
        }
      });
    },
    cancelScriptData() {
      this.closePopup();
    },
    validateNull(rule, value, callback) {
      if (isUndefined(value) || value === '' || isNil(value)) {
        callback(new Error());
      } else {
        callback();
      }
    },
    changeSelectNode(selectedData) {
      this.scriptTypeId = selectedData;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/ScriptSettings/popup/ScriptSettingPopup.vue